
const yorumDurumOptions = [
    {
        value: 0,
        text: "Onay Bekleyen"
    },
    {
        value: 1,
        text: "Onaylanmış"
    },
    {
        value: 2,
        text: "Reddedilmiş"
    },
]


export {yorumDurumOptions}